import React from "react";

export default function Loading({ text = "Загрузка…" }) {
  return (
    <div className="loading-container">
      <div className="loading-spinner" />
      <span className="loading-text">{text}</span>
    </div>
  );
}
